import service from '@/services/SICUDsubirdoc';

export default {
  namespaced: true,

  state: {
    numberDocument: null,
    nit: null,
  },

  mutations: {
    SET_DATA_RESULT(state, data) {
      if (!state.numberDocument) {
        state.numberDocument = data.doc_num;
      }

      if (!state.nit) {
        state.nit = data.ter_nit;
      }
    },
  },

  actions: {
    /**
     * Petición para agregar una cuenta a una sala.
     *
     * sal_cod: Obligatorio, id de sala.
     *
     * sal_par_his: Obligatorio, tipo de acceso al chat [0|1]:
     * 0: acceso al historial.
     * 1: acceso durante permanencia en sala.
     *
     * usr__cod: Obligatorio en caso de agregar una cuenta Integrity, id de usuario.
     * usr_lgn_mail: Obligatorio en caso de agregar una cuenta de email, cuenta de email.
     */
    async read({ commit, dispatch, rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDsubirdoc: {
            eeDatos: [rootGetters['auth/state']],
            eesubirdoc: [
              {
                picsal_bol: obj.type === '36' ? obj.documentFileFrom : obj.documentFileBack,
                picsal_cod: rootGetters['SICUDgpd_est_crd/state'].roomId || null,
                ocr_doc_tip: obj.type || '36',
                picdoc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || null,
              },
            ],
            eecon_fto: [],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data.dsSICUDsubirdoc;

            if (data.eeEstados[0].Returnid === 0) {
              const { eegpd_pr_est: [ocr] } = JSON.parse(data.eesubirdoc[0].ocr_out);
              commit('SET_DATA_RESULT', ocr);
              // Usamos root: true para poder acceder a otros módulos
              if (ocr.ter_nit) {
                commit('SICUDgpd_est_crd/SET_NIT_EXTERNAL', ocr.ter_nit, { root: true });
              }
              resolve(data.eesubirdoc);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve();
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: error.name || undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },

    setDataResult({ commit }, data) {
      commit('SET_DATA_RESULT', data);
    },

  },

  getters: {
    state(state) {
      return {
        ...state,
      };
    },
  },
};
